'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function RUFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-uy1guev1v", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-0igxospvw", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-5gedszndl" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-5gedszndl", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-uy1guev1v)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3d58db", xlinkHref: "#mantine-5gedszndl" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h32v8H0z", mask: "url(#mantine-0igxospvw)" }), /* @__PURE__ */ React.createElement("path", { fill: "#c51918", d: "M0 16h32v8H0z", mask: "url(#mantine-0igxospvw)" })))
  );
}

export { RUFlag };
//# sourceMappingURL=RU.mjs.map
